import React from "react";
/*
 * An applied setState closure (see setState.ts for the original pattern)
 *
 * When to use it?
 * When you have a simple change of state that sets one value
 * such as
 *
 * () => setOpen(true)
 *
 * which is equivalent to
 * setStateValue(setOpen, true)
 *
 * Why to use it?
 * It will help you with annoying code coverage where you are
 * doing a simple setState: forget istanbul statements
 *
 * Example of usage:
 * const [open, setOpen] = React.useState(false);
 * // ... some code ...
 * <Button text="Open" onClick={setStateValue(setOpen, true)}/>
 */

export function setStateValue<T, V extends T>(
  setState: React.Dispatch<React.SetStateAction<T>>,
  value: V | React.SetStateAction<T>
) {
  return () => {
    setState(value);
  };
}
